var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-vh d-flex flex-column align-center justify-center",attrs:{"id":"humans-outro"}},[_c('v-fade-transition',[_c('ChatAvatar',{attrs:{"dialogs":_vm.dialog,"entry":_vm.dialogEntry}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }